export default __webpack_public_path__ + "static/media/data2.95be06e8.gif";